import { apiClient } from '../api-client';
import { ApiError } from '../../dtos/common/api.dto';
import type { AuditLogDownloadRequest, AuditLogDownloadResponse } from '../../dtos/admin/audit-log.dto';

export class AuditLogService {
  static async requestDownload(
    request: AuditLogDownloadRequest
  ): Promise<AuditLogDownloadResponse> {
      const params: Record<string, string> = {
        startDate: request.startDate,
        endDate: request.endDate,
        format: request.format || 'CSV',
      };
      // AUD-03 filters
      if (request.userId) params.userId = request.userId;
      if (request.patientId) params.patientId = request.patientId;
      if (request.action) params.action = request.action;
      const response = await apiClient.get<AuditLogDownloadResponse>('/admin/audit/phi/download', params);
      if (!response.data) {
        throw new Error('Audit log export did not return a download');
      }
      return response.data;
  }

  static async downloadFile(downloadUrl: string, fileName: string): Promise<void> {
    try {
      const response = await fetch(downloadUrl);
      if (!response.ok) {
        throw new Error('Failed to download audit log file');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading audit log:', error);
      throw new Error('Failed to download audit log file');
    }
  }
}

export default AuditLogService;
